/**
 * @author       julian@zumper.com (Julian Napolitan)
 * @copyright    Copyright (c) 2019, Zumper
 * @description  AutocompleteMobileBackButton component
 */

import React from 'react'
import type { AutocompleteTheme } from '../constants'

import mobileBackBtn from '../../../../shared/components/svg/left_chevron.svg'

export interface AutocompleteMobileBackButtonProps {
  onClick: () => void
  theme: AutocompleteTheme
}

export const AutocompleteMobileBackButton = ({
  onClick,
  theme,
}: AutocompleteMobileBackButtonProps) => {
  return (
    <button className={theme.backBtn} onClick={onClick}>
      <img alt="back" height={23} loading="lazy" src={mobileBackBtn} width={23} />
    </button>
  )
}
